import * as actionTypes from './actions';
export const initialState = {
    modalOpen: false,
    modalType: null,
    items: [],
    selectedItem: {},
    templateType: 'all',
    currentPage: 1,
    itemsPerPage: 12,
    paginationMeta: {},
    reload: false,
    isLoading: true,
    userSelectedItems: [],
    searchText: '',
    isAllChecked: false,
    allQuestionRegistries: [],
    hasInputValue: false,
    hasInputNoChange: true,
    isConfirmationModalOpen: false,
    lockedQuestionRegistryAddCount: 0,
    unLockedQuestionRegistryAddCount: 0,
    selectedCsvFile: null,
    selectCsvFileName: '',
    parsedCsvData: [],
    selectedCsvItemIndex: -1,
    selectedCsvItem: null
};
const authReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setModalOpen:
            return {
                ...state,
                modalOpen: action.modalOpen
            };
        case actionTypes.setModalType:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.setItems:
            return {
                ...state,
                items: action.items
            };
        case actionTypes.setSelectedItem:
            return {
                ...state,
                selectedItem: action.selectedItem
            };
        case actionTypes.setTemplateType:
            return {
                ...state,
                templateType: action.templateType
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        case actionTypes.setItemsPerPage:
            return {
                ...state,
                itemsPerPage: action.itemsPerPage
            };
        case actionTypes.setPaginationMeta:
            return {
                ...state,
                paginationMeta: action.paginationMeta
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setIsLoading:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case actionTypes.setSelectedItems:
            return {
                ...state,
                userSelectedItems: action.userSelectedItems
            };
        case actionTypes.setSearchText:
            return {
                ...state,
                searchText: action.searchText
            };
        case actionTypes.setAllQuestionRegistriesIds:
            return {
                ...state,
                allQuestionRegistries: action.allQuestionRegistries
            };
        case actionTypes.setAllChecked:
            return {
                ...state,
                isAllChecked: action.isAllChecked
            };
        case actionTypes.setActionType:
            return {
                ...state,
                typeOfAction: action.typeOfAction
            };
        case actionTypes.setHasInputChange:
            return {
                ...state,
                hasInputValue: action.hasInputValue
            };
        case actionTypes.setHasInputNoChange:
            return {
                ...state,
                hasInputNoChange: action.hasInputNoChange
            };
        case actionTypes.setIsConfirmationModalOpen:
            return {
                ...state,
                isConfirmationModalOpen: action.isConfirmationModalOpen
            };
        case actionTypes.clearAddEditModalValue:
            return {
                ...state,
                hasInputValue: false,
                hasInputNoChange: true
            };
        case actionTypes.setLockedTime:
            return {
                ...state,
                lockedTime: action.lockedTime
            };
        case actionTypes.setLockedAddToRegistryQuestionCount:
            return {
                ...state,
                lockedQuestionRegistryAddCount: action.lockedQuestionRegistryAddCount
            };
        case actionTypes.setUnLockedAddToRegistryQuestionCount:
            return {
                ...state,
                unLockedQuestionRegistryAddCount: action.unLockedQuestionRegistryAddCount
            };
        case actionTypes.setSelectedCsvFile:
            return {
                ...state,
                selectedCsvFile: action.selectedCsvFile
            };
        case actionTypes.setSelectedCsvFileName:
            return {
                ...state,
                selectCsvFileName: action.selectCsvFileName
            };
        case actionTypes.setParseDataOfCsvFile:
            return {
                ...state,
                parsedCsvData: action.parsedCsvData
            };
        case actionTypes.setSelectedCsvItem:
            return {
                ...state,
                selectedCsvItem: action.selectedCsvItem
            };
        case actionTypes.setSelectedCsvItemIndex:
            return {
                ...state,
                selectedCsvItemIndex: action.selectedCsvItemIndex
            };
        default:
            return state;
    }
};

export default authReducer;
